<template>
  <div v-if="!hiddenFooter" :class="device === 'mobile' ? 'mobile-high-footer' : 'high-footer'" id="footer">
    <div class="footer-panel">
      <div class="footer-left">
        <div class="footer-left-top">
          <img class="footer-logo" src="../../assets/img/logo_small.png" alt="">
        </div>
        <div class="footer-left-middle">
          <div class="tel-icon">
            <i class="el-icon-phone-outline"></i>
          </div>
          <div class="tel-text">
            <p>热线电话</p>
            <p>020-31958939</p>
          </div>
        </div>
        <div class="footer-left-bottom">
          <a href="http://beian.miit.gov.cn/" target="_blank">
            广东高成长企业发展服务中心有限公司  备案号：粤ICP备19004887号
          </a>
        </div>
      </div>
      <img src="../../assets/img/qrcode.jpg"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HighFooter',
  computed: {
    device(){
      return this.$store.state.app.device
    },
    classObj(){
      return {
        mobile: this.device === 'mobile'
      }
    }
  },
  data() {
    return {
      bottomDataForm: {},
      hiddenFooter:false
    };
  },
  mounted () {
    this.hiddenFooter = this.$route.meta.hiddenFooter
  },
  watch:{
    $route () {
      this.hiddenFooter = this.$route.meta.hiddenFooter
    }
  },

}
</script>

<style lang='scss' scoped>

.mobile-high-footer{
  width: 100%;
  background: #192233;
  .footer-panel{
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: p2r(20px) p2r(17px);
    .footer-left{
      .footer-left-top{
        font-size: p2r(14px);
        margin-bottom: p2r(20px);
        color: #ffffff;
        .footer-logo {
          height: p2r(30px);
        }
      }
      .footer-left-middle{
        display: flex;
        align-items: center;
        margin-bottom: p2r(15px);
        .tel-icon{
          width: p2r(30px);
          height: p2r(30px);
          border-radius: 50%;
          line-height: p2r(30px);
          border: 2px solid #ffffff;
          color: #ffffff;
          text-align: center;
          font-size: p2r(17px);
          margin-right: p2r(10px);
        }
        .tel-text{
          color: #ffffff;
          p{
            &:nth-of-type(1){
              font-size: p2r(10px);
              height: p2r(10px);
              line-height: p2r(10px);
              margin-bottom: 10px;
            }
            &:nth-of-type(2){
              font-size: p2r(10px);
              height: p2r(10px);
              line-height: p2r(10px);
            }
          }
        }
      }
      .footer-left-bottom{
        font-size: p2r(10px);
        color: #999;
        line-height: 1.4;
      }
    }
    img{
      height: p2r(70px);
    }
  }
}
.high-footer{
  width: 100%;
  height: p2r(250px);
  background: #192233;
  box-sizing: border-box;
  .footer-panel{
    max-width: p2r(1200px);
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: p2r(40px);
    height: 100%;
    box-sizing: border-box;
    .footer-left{
      .footer-left-top{
        font-size:p2r(24px);
        margin-bottom: p2r(30px);
        color: #ffffff;

        .footer-logo {
          height: p2r(50px);
          width: auto;
          display: inline-block;
        }
      }
      .footer-left-middle{
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        .tel-icon{
          width: p2r(60px);
          height: p2r(60px);
          border-radius: 50%;
          line-height: p2r(60px);
          border: 2px solid #ffffff;
          color: #ffffff;
          text-align: center;
          font-size: 34px;
          margin-right: p2r(20px);
        }
        .tel-text{
          color: #ffffff;
          p{
            &:nth-of-type(1){
              font-size: 16px;
              height: p2r(16px);
              line-height: p2r(16px);
              margin-bottom: 10px;
            }
            &:nth-of-type(2){
              font-size: 24px;
              height: p2r(24px);
              line-height: p2r(24px);
            }
          }
        }
      }
      .footer-left-bottom{
        font-size: 14px;
        a {
          color: #999;
        }
      }
    }
    img{
      height: p2r(168px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footerComp/high-footer.vue